<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <div class="page-header">
        <div class="row align-items-center w-100">
          <div class="col-sm-8 d-flex align-items-center flex-wrap">
            <div>
              <h3 class="page-title mb-1 d-flex align-items-center">
                <i class="fa fa-truck mr-2 text-primary"></i>
                Đơn Vận Chuyển (Sales)
              </h3>
              <ul class="breadcrumb mb-0 small">
                <li class="breadcrumb-item"><router-link to="/">Dashboard</router-link></li>
                <li class="breadcrumb-item active">Đơn hàng (Sales)</li>
              </ul>
            </div>
          </div>

          <div class="col-sm-4 text-right">
            <div class="btn-group mr-2">
              <button
                class="btn btn-outline-secondary btn-sm"
                :class="{ active: viewMode==='table' }"
                @click="viewMode='table'"
                title="Bảng"
              >
                <i class="fa fa-list mr-1"></i> Bảng
              </button>
              <button
                class="btn btn-outline-secondary btn-sm"
                :class="{ active: viewMode==='card' }"
                @click="viewMode='card'"
                title="Thẻ"
              >
                <i class="fa fa-th-large mr-1"></i> Card
              </button>
              <button
                class="btn btn-outline-secondary btn-sm"
                :class="{ active: viewMode==='kanban' }"
                @click="viewMode='kanban'"
                title="Kanban"
              >
                <i class="fa fa-columns mr-1"></i> Kanban
              </button>
            </div>

            <button class="btn btn-primary btn-sm" @click="openCreateModal">
              <i class="fa fa-plus"></i> Tạo Yêu cầu
            </button>
          </div>
        </div>
      </div>

      <div class="card card-tabs mb-3">
        <div class="card-header p-0 border-bottom-0">
          <div class="nav-tabs-scrollable">
            <ul class="nav nav-tabs nav-tabs-bottom">
              <li class="nav-item" v-for="tab in tabs" :key="tab.value">
                <a
                  class="nav-link"
                  href="#"
                  :class="{ active: filterTrangThai === tab.value }"
                  @click.prevent="applyFilterTab(tab.value)"
                >
                  <i v-if="tab.icon" :class="['mr-1', tab.icon]"></i>{{ tab.label }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div v-if="viewMode==='table'" class="card">
        <div class="card-body p-0">
          <div v-if="isLoadingList && items.length === 0" class="p-4 text-center">Đang tải...</div>
          <div v-else-if="listError && items.length === 0" class="alert alert-danger m-3">{{ listError }}</div>
          <div v-else-if="items.length === 0" class="p-4 text-center text-muted">Không có đơn hàng nào.</div>

          <div v-else class="table-responsive">
            <table class="table table-hover table-striped mb-0">
              <thead class="thead-light">
                <tr>
                  <th>Tên Công trình / Đơn hàng</th>
                  <th>NV Kinh Doanh</th>
                  <th>NV Kho</th>
                  <th>Tài xế</th>
                  <th>Trạng thái</th>
                  <th>Ghi chú Kho</th>
                  <th>Lộ trình</th>
                  <th class="text-right">Chi tiết</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.id"
                  @click="handleOpenDetail(item.id)"
                  style="cursor:pointer;"
                >
                  <td>
                    <strong class="d-block">{{ item.tenDonHang }}</strong>
                    <small class="text-muted text-truncate d-block" style="max-width:300px;">
                      Giao tới: {{ item.diaChiGiaoHang }}
                    </small>
                  </td>
                  <td><small>{{ item.tenNguoiTao }}</small></td>
                  <td><small>{{ item.tenNguoiXuLyKho || '-' }}</small></td>
                  <td><small>{{ item.tenTaiXe || '-' }}</small></td>
                  <td>
                    <span class="badge" :class="getOrderStatusBadge(item.trangThai)">
                      {{ formatOrderStatus(item.trangThai) }}
                    </span>
                  </td>
                  <td class="text-danger font-weight-bold">
                    {{ item.ghiChuKho }}
                  </td>
                  <td>
                    <span class="badge badge-light">
                      {{ (item.diemDung && item.diemDung.length) || 0 }} điểm dừng
                    </span>
                  </td>
                  <td class="text-right">
                    <button
                      class="btn btn-sm btn-outline-primary"
                      @click.stop="handleOpenDetail(item.id)"
                    >
                      <i class="fa fa-eye"></i> Xem
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>

      <div v-else-if="viewMode==='card'">
        <div v-if="isLoadingList && items.length===0" class="p-4 text-center">Đang tải...</div>
        <div v-else-if="listError && items.length===0" class="alert alert-danger m-3">{{ listError }}</div>
        <div v-else-if="items.length===0" class="p-4 text-center text-muted">Không có đơn hàng nào.</div>

        <div v-else class="row">
          <div
            class="col-md-6 col-xl-4 mb-3"
            v-for="item in items"
            :key="item.id"
          >
            <div class="card shadow-sm h-100 border cursor-pointer hover-card" @click="handleOpenDetail(item.id)">
              <div class="card-body">
                <div class="d-flex justify-content-between mb-2">
                  <div class="font-weight-bold text-truncate" style="max-width:70%">
                    {{ item.tenDonHang }}
                  </div>
                  <div class="text-right">
                    <span class="badge mr-1" :class="getOrderStatusBadge(item.trangThai)">
                      {{ formatOrderStatus(item.trangThai) }}
                    </span>
                    <span class="badge" :class="getLoaiBadge(item.loaiDonHang)">
                      {{ formatLoai(item.loaiDonHang) }}
                    </span>
                  </div>
                </div>

                <div class="small text-muted mb-2">
                  <i class="fa fa-map-marker text-danger mr-1"></i>
                  {{ item.diaChiGiaoHang || '-' }}
                </div>

                <div class="mb-2">
                  <div class="d-flex align-items-center small">
                    <i class="fa fa-user mr-2 text-secondary"></i>
                    <div>
                      <div><strong>Sales:</strong> {{ item.tenNguoiTao || '-' }}</div>
                      <div><strong>Kho:</strong> {{ item.tenNguoiXuLyKho || '-' }}</div>
                      <div><strong>Tài xế:</strong> {{ item.tenTaiXe || '-' }}</div>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-between align-items-center flex-wrap">
                  <div class="small mb-1">
                    <i class="fa fa-road mr-1"></i>
                    {{ (item.diemDung && item.diemDung.length) || 0 }} điểm dừng
                  </div>

                  <div class="text-right">
                    <button
                      class="btn btn-xs btn-outline-primary"
                      @click.stop="handleOpenDetail(item.id)"
                    >
                      <i class="fa fa-eye"></i> Xem
                    </button>
                  </div>
                </div>

                <div v-if="item.ghiChuKho" class="alert alert-warning py-1 px-2 mt-2 mb-0 small">
                  <i class="fa fa-exclamation-triangle mr-1"></i>
                  {{ item.ghiChuKho }}
                </div>
              </div>

              <div class="card-footer text-right small text-muted">
                <i class="fa fa-clock-o mr-1"></i>
                {{ item.ngayTao ? formatDateTime(item.ngayTao) : '---' }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="viewMode==='kanban'" class="kanban-wrapper">
        <div class="kanban-scroll">
          <div
            class="kanban-col"
            v-for="col in kanbanColumns"
            :key="col.key"
          >
            <div class="kanban-header">
              <div class="font-weight-bold d-flex align-items-center">
                <span class="kanban-dot mr-2" :class="'dot-'+col.key"></span>
                {{ col.title }}
              </div>
              <div class="badge badge-light">{{ groupedByStatus[col.key]?.length || 0 }}</div>
            </div>

            <div class="kanban-body">
              <div
                v-for="item in groupedByStatus[col.key]"
                :key="item.id"
                class="kanban-card"
                @click="handleOpenDetail(item.id)"
              >
                <div class="d-flex justify-content-between mb-1">
                  <div class="font-weight-bold text-truncate" style="max-width:70%">{{ item.tenDonHang }}</div>
                  <span class="badge badge-light">{{ formatLoai(item.loaiDonHang) }}</span>
                </div>

                <div class="small text-muted text-truncate">
                  <i class="fa fa-map-marker text-danger mr-1"></i>
                  {{ item.diaChiGiaoHang || '-' }}
                </div>

                <div class="small mt-2">
                  <div><strong>Kho:</strong> {{ item.tenNguoiXuLyKho || '-' }}</div>
                  <div><strong>Tài xế:</strong> {{ item.tenTaiXe || '-' }}</div>
                  <div>
                    <i class="fa fa-road mr-1"></i>
                    {{ (item.diemDung && item.diemDung.length) || 0 }} điểm dừng
                  </div>
                </div>

                <div
                  v-if="item.ghiChuKho"
                  class="small mt-2 text-danger font-weight-bold"
                >
                  <i class="fa fa-exclamation-circle mr-1"></i>{{ item.ghiChuKho }}
                </div>

                <div class="kanban-footer small text-muted mt-2">
                  <i class="fa fa-clock-o mr-1"></i>
                  {{ item.ngayTao ? formatDateTime(item.ngayTao) : '---' }}
                </div>
              </div>

              <div v-if="!groupedByStatus[col.key] || groupedByStatus[col.key].length===0"
                   class="kanban-empty small text-muted text-center py-3">
                (Không có đơn)
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="showModal"
        class="modal fade show d-block"
        tabindex="-1"
        style="background:rgba(0,0,0,.5);"
      >
        <div
          v-if="!isEdit"
          class="modal-dialog modal-lg"
          role="document"
        >
          <div class="modal-content create-modal-wrapper">
            <form @submit.prevent="submitCreateForm">
              <div class="modal-header bg-primary text-white align-items-start">
                <div>
                  <div class="d-flex align-items-center">
                    <i class="fa fa-plus-circle mr-2"></i>
                    <h5 class="modal-title font-weight-bold mb-0">
                      Tạo Yêu cầu Vận chuyển
                    </h5>
                  </div>
                  <div class="small mt-1 text-white-50">
                    Điền nhanh. Có thể dán ảnh từ clipboard.
                  </div>
                </div>
                <button type="button" class="close text-white" @click="closeModal">
                  <span>&times;</span>
                </button>
              </div>

              <div class="modal-body">
                <div v-if="formError" class="alert alert-danger py-2">{{ formError }}</div>

                <div class="create-grid">
                  <div class="create-left">
                    <div class="section-block">
                      <div class="section-title">
                        <span class="badge badge-primary mr-2">1</span>
                        Thông tin chung
                      </div>

                      <div class="form-group">
                        <label class="required-label">Tên đơn hàng</label>
                        <input
                          v-model.trim="form.tenDonHang"
                          type="text"
                          class="form-control form-control-lg"
                          placeholder="Vui lòng nhập tên đơn hàng (bắt buộc)!"
                          required
                        />
                      </div>

                      <div class="form-group">
                        <div class="d-flex justify-content-between align-items-center mb-1">
                          <label class="mb-0">Thời gian hẹn (nếu có)</label>
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-info"
                            @click="setTomorrowTime"
                          >
                            Mai giao
                          </button>
                        </div>

                        <input
                          v-model.trim="form.thoiGianHenText"
                          type="text"
                          class="form-control"
                          placeholder="dd/MM/yyyy HH:mm:ss (VD: 31/10/2025 14:30:00)"
                          @input="updateThoiGianHenPreview"
                        />

                        <small class="form-text text-muted mt-1" v-if="thoiGianHenPreview">
                          <i class="fa fa-clock-o mr-1"></i>
                          {{ thoiGianHenPreview }}
                        </small>

                        <small class="form-text text-danger mt-1" v-else-if="form.thoiGianHenText">
                          <i class="fa fa-exclamation-triangle mr-1"></i>
                          Không đọc được thời gian. Định dạng: dd/MM/yyyy HH:mm:ss
                        </small>
                      </div>

                       <div class="form-row align-items-center">
                        <div class="form-group col-md-8">
                          <label class="required-label">Loại đơn</label>
                          <select
                            v-model="form.loaiDonHang"
                            class="form-control"
                            required
                            @change="onLoaiDonHangChange"
                          >
                            <option value="LAY_HANG">Lấy hàng (Lại kho lấy)</option>
                            <option value="GIAO_HANG">Giao hàng (Đã có hàng trên xe)</option>
                            <option value="KHACH_TU_LAY">Khách Tự Lấy (Tại Kho)</option>
                          </select>
                        </div>

                        <div class="form-group col-md-4">
                          <label class="mb-1 d-block">Giao gấp?</label>
                          <div class="custom-control custom-switch">
                            <input
                              v-model="form.giaoGap"
                              type="checkbox"
                              class="custom-control-input"
                              id="giaoGapSwitch"
                            />
                            <label class="custom-control-label" for="giaoGapSwitch">
                              Cần giao gấp
                            </label>
                          </div>
                        </div>
                      </div>
                    </div> 

                    <div class="section-block">
                      <div class="section-title">
                        <span class="badge badge-primary mr-2">2</span>
                        Giao hàng / Công trình
                      </div>

                       <div class="form-row">
                        <div class="form-group col-md-12">
                          <label class="label">Đơn vị mua hàng</label>
                          <input
                            v-model.trim="form.tenKhachHang"
                            type="text"
                            class="form-control"
                            placeholder="Vui lòng nhập tên đơn vị mua hàng..."
                          />
                        </div>
                        <div class="form-group col-md-12">
                          <label class="label">Địa chỉ Đơn vị mua hàng</label>
                          <input
                            v-model.trim="form.diaChiKhachHang"
                            type="text"
                            class="form-control"
                            placeholder="Nhập địa chỉ đơn vị mua hàng..."
                          />
                          <a
                            v-if="form.diaChiKhachHang"
                            href="#"
                            @click.prevent="openGoogleMaps(form.diaChiKhachHang)"
                            class="small d-inline-block mt-1"
                          >
                          <i class="fa fa-map-marker text-danger mr-1"></i>
                          Xem trên Google Maps
                        </a>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="label">Tên công trình</label>
                        <input
                          v-model.trim="form.tenCongTrinh"
                          type="text"
                          class="form-control"
                          placeholder="Nhập tên công trình nếu có..."
                          />
                      </div>
       
                      <div class="form-group">
                        <label class="required-label">Địa chỉ giao hàng (Công trình)</label>
                        <input
                          v-model.trim="form.diaChiGiaoHang"
                          type="text"
                          class="form-control"
                          placeholder="Vui lòng nhập địa chỉ giao hàng (công trình)..."
                          required
                        />
                        <a
                          v-if="form.diaChiGiaoHang"
                          href="#"
                          @click.prevent="openGoogleMaps(form.diaChiGiaoHang)"
                          class="small d-inline-block mt-1"
                        >
                          <i class="fa fa-map-marker text-danger mr-1"></i>
                          Xem trên Google Maps
                        </a>
                      </div>

                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <label class="required-label">Tên người nhận</label>
                          <input
                            v-model.trim="form.tenNguoiNhan"
                            type="text"
                            class="form-control"
                            placeholder="Vui lòng nhập tên người nhận..."
                            required
                          />
                        </div>
                        <div class="form-group col-md-6">
                          <label class="required-label">SĐT người nhận</label>
                          <input
                            v-model.trim="form.sdtNguoiNhan"
                            type="text"
                            class="form-control"
                            placeholder="Vui lòng nhập SĐT người nhận..."
                            required
                          />
                        </div>
                      </div>

                    </div>
                  </div>

                  <div class="create-right">
                    <div class="section-block">
                      <div class="section-title d-flex justify-content-between align-items-center">
                        <div>
                          <span class="badge badge-primary mr-2">3</span>
                          Phiếu vật tư
                        </div>
                        <span class="small text-muted">(Zalo, phiếu kho, Excel khách gửi...)</span>
                      </div>

                      <div class="form-group mb-2">
                    
                        <label class="required-label d-flex justify-content-between align-items-center flex-wrap">
                          <span>Ảnh/File đính kèm <span class="text-danger">*</span></span>
                          <span class="small text-muted font-italic">
                            Dán (Ctrl+V) / Chọn file
                          </span>
                        </label>

                        <div
                          class="upload-dropzone"
                          :class="{ 'is-uploading': isUploading }"
                          @paste.prevent="handlePaste"
                        >
                          <div class="d-flex align-items-center flex-wrap">
                            <div class="flex-grow-1 w-100">
                              <input
                                v-model.trim="form.fileUrl"
                                type="text"
                                class="form-control form-control-sm mb-2"
                                placeholder="Dán link (hoặc Ctrl+V / Chọn file để upload)"
                                required
                              />
                            </div>

                            <div class="w-100 mt-1">
                              <input
                                ref="fileInputEl"
                                type="file"
                                accept="image/*"
                                class="d-none"
                                @change="handleFileSelect"
                              />
                              <button
                                type="button"
                                class="btn btn-sm btn-outline-secondary"
                                @click.stop="triggerFileSelect"
                                :disabled="isUploading"
                              >
                                <i class="fa fa-upload mr-1"></i> Chọn ảnh từ máy
                              </button>

                              <span v-if="isUploading" class="ml-2 small text-muted">
                                <span class="spinner-border spinner-border-sm"></span>
                                Đang tải lên...
                              </span>
                              <span v-if="uploadError" class="ml-2 small text-danger">
                                {{ uploadError }}
                              </span>
                              </div>
                          </div>

                          <div class="preview-area mt-2" v-if="previewSource">
                            <div class="preview-thumb clickable-thumb" @click.stop="openLightboxFromPreview">
                              <img
                                :src="previewSource"
                                class="img-fluid rounded border"
                                style="max-height:120px;object-fit:cover"
                                alt="Preview"
                              />
                            </div>
                            <div class="small text-primary mt-1">
                              <i class="fa fa-search-plus mr-1"></i>
                              Nhấn để phóng to
                            </div>
                          </div>

                          <div v-else-if="!isUploading" class="text-muted small mt-2">
                            <i class="fa fa-image mr-1"></i>
                            Ctrl+V hình / Chọn file / Dán link...
                          </div>
                        </div>
                      </div>

                      <div class="form-group mt-3">
                        <label class="label">Ghi chú chung <span class="text-danger">*</span></label>
                        <textarea
                          v-model.trim="form.ghiChuSales"
                          class="form-control"
                          rows="4"
                          placeholder="Ghi chú của bộ phận bán hàng cho (kho hoặc tài xế)..."
                          required
                        ></textarea>
                      </div>

                      <vue-easy-lightbox
                        :visible="lightboxVisible"
                        :imgs="lightboxImages"
                        :index="0"
                        @hide="closeLightbox" 
                      />
                    </div>


                    <div class="section-block">
                      <div class="section-title">
                        <span class="badge badge-primary mr-2">4</span>
                        Hoạch định Lộ trình (tuỳ chọn)
                      </div>

                      <p class="small text-muted mb-2">
                        Nếu biết hàng ở đâu cứ nhập trước. Nếu không biết thì bỏ trống, Kho sẽ hoạch định sau.
                      </p>

                      <div v-if="isLoadingOptions" class="text-center text-muted small">
                        Đang tải danh sách NV Kho...
                      </div>

                      <ul
                        v-if="formHoachDinh.diemDungList.length > 0"
                        class="list-group list-group-sm mb-2"
                      >
                        <li
                          v-for="(stop, index) in formHoachDinh.diemDungList"
                          :key="index"
                          class="list-group-item"
                        >
                          <div class="d-flex justify-content-between">
                            <div>
                              <strong>{{ stop.tenDiemDung }}</strong>
                              <small class="text-muted ml-1">
                                ({{ formatLoaiDiemDung(stop.loaiDiemDung) }})
                              </small>

                              <div v-if="stop.diaChi" class="small text-muted">
                                {{ stop.diaChi }}
                              </div>

                              <div class="small text-primary">
                                Phụ trách: {{ getKhoNhanVienName(stop.nguoiPhuTrachKhoId) || 'Chưa gán' }}
                              </div>
                            </div>

                            <button
                              type="button"
                              class="btn btn-sm btn-outline-danger"
                              @click="removeStop(index)"
                            >
                              <i class="fa fa-trash"></i>
                            </button>
                          </div>
                        </li>
                      </ul>

                      <div class="border rounded p-2 bg-light">
                        <div class="small font-weight-bold mb-2">
                          Thêm Điểm Dừng
                        </div>

                        <div class="form-group mb-2">
                          <input
                            v-model.trim="formDiemDungMoi.tenDiemDung"
                            class="form-control form-control-sm"
                            placeholder="Vui lòng nhập tên kho, hoặc nơi lấy..."
                          />
                        </div>

                        <div class="form-group mb-2">
                          <input
                            v-model.trim="formDiemDungMoi.diaChi"
                            class="form-control form-control-sm"
                            placeholder="Vui lòng nhập địa chỉ..."
                          />
                        </div>

                        <div class="form-group mb-2">
                          <input
                            v-model.trim="formDiemDungMoi.chiTietVatTu"
                            class="form-control form-control-sm"
                            placeholder="Ghi chú vật tư tại từng kho (nếu có)..."
                          />
                        </div>

                        <div class="form-row">
                          <div class="form-group col-md-6">
                            <label class="small mb-1">Loại điểm dừng</label>
                            <select
                              v-model="formDiemDungMoi.loaiDiemDung"
                              class="form-control form-control-sm"
                            >
                              <option value="KHO_LAY">Lấy hàng tại Kho (Tài xế lấy)</option>
                              <option value="KHACH_TU_LAY">Khách Tự Lấy (Tại Kho)</option>
                            </select>
                          </div>

                          <div class="form-group col-md-6">
                            <label class="small mb-1 d-block">
                              Gán NV Kho phụ trách
                            </label>
                            <select
                              v-model="formDiemDungMoi.nguoiPhuTrachKhoId"
                              class="form-control form-control-sm"
                              :disabled="isLoadingOptions"
                            >
                              <option :value="null" disabled>-- Chọn NV Kho --</option>
                              <option
                                v-for="nv in khoNhanVienOptions"
                                :key="nv.idNguoiDung"
                                :value="nv.idNguoiDung"
                              >
                                {{ nv.hoTen }}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="text-right">
                          <button
                            type="button"
                            class="btn btn-sm btn-secondary"
                            @click="addStop"
                          >
                            <i class="fa fa-plus"></i> Thêm Điểm
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div class="modal-footer d-flex justify-content-between flex-wrap">
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  @click="closeModal"
                >
                  Hủy bỏ
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="isLoadingDetail || isLoadingOptions"
                >
                  <span
                    v-if="isLoadingDetail || isLoadingOptions"
                    class="spinner-border spinner-border-sm"
                  ></span>
                  Gửi Yêu cầu
                </button>
              </div>
            </form>
          </div>
        </div>

        <div
          v-else
          class="modal-dialog modal-lg"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header bg-light">
              <h5 class="modal-title font-weight-bold">
                <i class="fa fa-file-text-o mr-2"></i>
                Chi tiết Đơn hàng
              </h5>
              <button type="button" class="close" @click="closeModal">
                <span>&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div v-if="isLoadingDetail" class="text-center my-4">
                <div class="spinner-border"></div>
                <div class="text-muted small mt-2">Đang tải chi tiết...</div>
              </div>

              <div v-else-if="detailError" class="alert alert-danger">
                {{ detailError }}
              </div>

              <div v-else-if="!currentOrder" class="text-muted text-center my-4">
                Không tìm thấy dữ liệu đơn hàng.
              </div>

              <div v-else>
                <div class="d-flex align-items-center justify-content-between flex-wrap mb-3">
                  <div>
                    <div class="h5 mb-1">{{ currentOrder.tenDonHang }}</div>
                    <div class="text-muted small">
                      <i class="fa fa-hashtag mr-1"></i>ID: {{ currentOrder.id }}
                      <span class="mx-2">•</span>
                      <i class="fa fa-user mr-1"></i>Sales: {{ currentOrder.tenNguoiTao || '-' }}
                      <span v-if="currentOrder.ngayTao" class="mx-2">•</span>
                      <span v-if="currentOrder.ngayTao">
                        <i class="fa fa-clock-o mr-1"></i>{{ formatDateTime(currentOrder.ngayTao) }}
                      </span>
                    </div>
                  </div>
                  <div class="text-right">
                    <span class="badge" :class="getOrderStatusBadge(currentOrder.trangThai)">
                      {{ formatOrderStatus(currentOrder.trangThai) }}
                    </span>
                    <span class="badge ml-2" :class="getLoaiBadge(currentOrder.loaiDonHang)">
                      {{ formatLoai(currentOrder.loaiDonHang) }}
                    </span>
                    <span v-if="currentOrder.giaoGap" class="badge badge-danger ml-2">
                      Gấp
                    </span>
                  </div>
                </div>

                <hr class="my-2"/>

                <div class="row">
                  <div class="col-md-6">
                    <h6 class="font-weight-bold text-primary mb-2">1. Thông tin Chung</h6>
                    <div class="mb-1"><strong>Đơn vị mua hàng:</strong> {{ currentOrder.tenKhachHang || '-' }}</div>
                    <div class="mb-1"><strong>Địa chỉ Đơn vị mua hàng:</strong> {{ currentOrder.diaChiKhachHang || '-' }}</div>
                    <div class="mb-1"><strong>Tên công trình:</strong> {{ currentOrder.tenCongTrinh || '-' }}</div>
                    <div class="mb-1"><strong>Địa chỉ giao:</strong> {{ currentOrder.diaChiGiaoHang || '-' }}</div>
                    <div class="mb-1"><strong>Người nhận:</strong> {{ currentOrder.tenNguoiNhan || '-' }}</div>
                    <div class="mb-1"><strong>SĐT người nhận:</strong> {{ currentOrder.sdtNguoiNhan || '-' }}</div>
                  </div>

                  <div class="col-md-6">
                    <h6 class="font-weight-bold text-primary mb-2">2. Giao hàng</h6>
                    <div class="mb-1" v-if="currentOrder.thoiGianHen">
                      <strong>Thời gian hẹn:</strong> {{ formatDateTime(currentOrder.thoiGianHen) }}
                    </div>
                      <div v-if="currentOrder.loaiDonHang === 'LAY_HANG' || currentOrder.loaiDonHang === 'LAY_HANG'">
                        <div class="mb-1"><strong>Hình thức:</strong>
                          <span class="badge badge-warning">Công ty vận chuyển</span>
                        </div>
                        <div class="mb-1"><strong>Nhân viên Kho:</strong> {{ currentOrder.tenNguoiXuLyKho || '-' }}</div>
                        <div class="mb-1"><strong>Tài xế:</strong> {{ currentOrder.tenTaiXe || '-' }}</div>
                        <div class="mb-1"><strong>Xe:</strong> {{ currentOrder.xeBienSo || '-' }}</div>
                      </div>

                      <div v-else-if="currentOrder.loaiDonHang === 'KHACH_TU_LAY'">
                        <div class="mb-1">
                          <strong>Hình thức:</strong>
                          <span class="badge badge-warning">Khách tự đến lấy</span>
                        </div>
                        <div class="mb-1"><strong>NV Kho xử lý:</strong> {{ currentOrder.tenNguoiXuLyKho || '-' }}</div>
                        <div class="mb-1">
                          <strong>Tên người lấy hàng:</strong>
                          <strong class="text-danger">{{ currentOrder.tenNguoiLayHangThucTe || '(Chưa cập nhật)' }}</strong>
                        </div>
                        <div class="mb-1">
                          <strong>Biển số xe khách:</strong>
                          <strong class="text-danger">{{ currentOrder.bienSoXeKhach || '(Chưa cập nhật)' }}</strong>
                        </div>
                      </div>
                    </div>
                </div>

    
                <hr class="my-3"/>

                <div>
                  <h6 class="font-weight-bold text-primary mb-2">3. Thông tin Vật tư (Sales cung cấp)</h6>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="mb-1">
                        <strong>Ảnh/File đính kèm (Zalo):</strong>

                        <div v-if="currentOrder.fileUrl" class="image-preview-container d-inline-block ml-2">
                          <img
                            :src="currentOrder.fileUrl"
                            alt="Ảnh Sales đính kèm"
                            class="preview-thumbnail" 
                            title="Nhấn để phóng to"
                          />
                        </div>

                        <span v-else class="text-muted ml-2">-</span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-1 text-danger">
                        <strong>Ghi chú cho kho:</strong> {{ currentOrder.ghiChuKho }}
                      </div>
                      <div class="mb-1 text-danger">
                        <strong>Ghi chú vật tư (Từ Sales):</strong>
                        <pre class="mt-1 rounded">{{ currentOrder.ghiChuSales }}</pre>
                      </div>
                    </div>
                  </div>
                </div>

                <hr class="my-3"/>    

                <div>
                  <h6 class="font-weight-bold text-primary mb-2">4. Lộ trình (Stops)</h6>
                  <div
                    v-if="!currentOrder.diemDung || currentOrder.diemDung.length === 0"
                    class="text-muted"
                  >
                    Chưa có lộ trình.
                  </div>
                  <div v-else class="table-responsive">
                    <table class="table table-sm table-hover">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>Điểm dừng</th>
                          <th>Địa chỉ</th>
                          <th>Loại</th>
                          <th>Vật tư/Ghi chú</th>
                          <th>NV Kho phụ trách</th>
                          <th>Trạng thái</th>
                          <th>Hình ảnh</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(st, idx) in currentOrder.diemDung"
                          :key="st.id || idx"
                        >
                          <td>{{ st.thuTu || idx + 1 }}</td>
                          <td>{{ st.tenDiemDung || '-' }}</td>
                          <td>{{ st.diaChi || '-' }}</td>
                          <td>
                            <span class="badge" :class="getLoaiBadgeStop(st.loaiDiemDung)">
                              {{ formatLoaiDiemDung(st.loaiDiemDung) }}
                            </span>
                          </td>
                          <td class="text-truncate" style="max-width:200px">
                            {{ st.chiTietVatTu || '-' }}
                          </td>
                          <td>{{ st.tenNguoiPhuTrachKho || '-' }}</td>

                          <td>
                            <span
                              v-if="getStopStatusBadge && formatStopStatus"
                              class="badge"
                              :class="getStopStatusBadge(st.trangThai)"
                            >
                              {{ formatStopStatus(st.trangThai) }}
                            </span>
                            <span v-else>{{ st.trangThai || '-' }}</span>
                          </td>
                          <td>
                            <div v-if="st.anhSoanHangUrl">
                              <div class="preview-thumb clickable-thumb" @click.stop="showStopImage(st.anhSoanHangUrl)">                  
                                <img
                                  :src="st.anhSoanHangUrl"
                                  class="img-fluid rounded border"
                                  style="max-height:120px; object-fit:cover"
                                  alt="Ảnh xác minh"
                                />
                              </div>
                            </div>
                            <span v-else>-</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div v-if="currentOrder.diemDung && currentOrder.diemDung.length">
                  <h6 class="font-weight-bold text-primary mt-3">5. Xác minh Khách Lấy Hàng</h6>

                  <div
                    v-for="(diem, idx) in currentOrder.diemDung"
                    :key="diem.id"
                    class="border rounded p-3 mb-3"
                  >
                    <h6 class="mb-2">
                      <i class="fa fa-map-marker text-danger mr-1"></i>
                      Điểm {{ idx + 1 }}: {{ diem.tenDiemDung }}
                      <span class="badge ml-2" :class="getStatusClass(diem.trangThai)">
                        {{ diem.trangThai }}
                      </span>
                    </h6>
                    <p><strong>Thời điểm đến:</strong> {{ formatDateTime(diem.thoiDiemDen) }}</p>
                    <p><strong>Thời điểm hoàn thành:</strong> {{ formatDateTime(diem.thoiDiemHoanThanh) }}</p>
                    <p><strong>Địa chỉ:</strong> {{ diem.diaChi }}</p>
                    <p><strong>Loại điểm dừng:</strong> {{ diem.loaiDiemDung }}</p>

                    <div v-if="diem.loaiDiemDung === 'KHACH_TU_LAY'">
                      <hr>
                      <div class="row">
                        <div class="col-md-6">
                          <label class="font-weight-bold">Tên người lấy hàng:</label>
                          <input
                            v-model.trim="currentOrder.tenNguoiLayHangThucTe"
                            type="text"
                            class="form-control"
                            :readonly="!isEditable"
                          />
                        </div>
                        <div class="col-md-6">
                          <label class="font-weight-bold">Biển số xe khách:</label>
                          <input
                            v-model.trim="currentOrder.bienSoXeKhach"
                            type="text"
                            class="form-control"
                            :readonly="!isEditable"
                          />
                        </div>
                      </div>

                      <div class="form-group mt-2">
                        <label class="font-weight-bold">Ảnh xác minh:</label>
                        <div v-if="diem.anhKhachLayUrl">
                          <a :href="diem.anhKhachLayUrl" target="_blank">
                            <img
                              :src="diem.anhKhachLayUrl"
                              class="img-fluid rounded shadow-sm"
                              style="max-height: 200px;"
                            >
                          </a>
                        </div>
                        <div v-else class="text-muted">Chưa có ảnh xác minh</div>

                        <div v-if="isEditable" class="mt-2">
                          <input
                            type="file"
                            accept="image/*"
                            capture="environment"
                            @change="handleImageUpload($event, diem)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="isEditable" class="text-right">
                  <button
                    class="btn btn-success"
                    :disabled="isSubmitting"
                    @click="savePickupConfirmations"
                  >
                    <span v-if="isSubmitting" class="spinner-border spinner-border-sm"></span>
                    Lưu cập nhật xác minh
                  </button>
                </div>

              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click="closeModal"
              >
                Đóng
              </button>

              <button
                v-if="currentOrder && currentOrder.trangThai==='CHO_SALES_XAC_NHAN_THIEU'"
                class="btn btn-warning"
                @click="handleConfirmShortage(currentOrder.id)"
              >
                <i class="fa fa-check-square-o mr-1"></i> Xác nhận thiếu
              </button>

              <button
                v-if="currentOrder && ['CHO_HOACH_DINH', 'CHO_SALES_XAC_NHAN_THIEU','DANG_CHUAN_BI_HANG'].includes(currentOrder.trangThai)"
                class="btn btn-danger"
                @click="handleCancelOrder(currentOrder.id)"
              >
                <i class="fa fa-ban mr-1"></i> Huỷ đơn
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'pinia'
import { useSalesDonHangStore } from '@/stores/salesDonHangStore'
import { formatDate, formatDateTime, normalizeDateTimeLocalForApi } from '@/helpers/datetime'
import { getOrderStatusBadge, formatOrderStatus } from '@/helpers/orderStatus'
import { getLoaiBadgeStop, formatLoaiDiemDung, getStopStatusBadge, formatStopStatus } from '@/helpers/stopHelpers'
import { openGoogleMaps } from '@/helpers/maps'
import { lockBodyScroll, unlockBodyScroll } from '@/helpers/dom'
import VueEasyLightbox from 'vue-easy-lightbox'
import fileService from '@/services/fileService'; 

const DEFAULT_CREATE_FORM = {
  tenDonHang: '',
  tenCongTrinh: '',
  loaiDonHang: 'LAY_HANG',
  tenKhachHang: '',
  diaChiKhachHang: '',
  tenNguoiNhan: '',
  sdtNguoiNhan: '',
  diaChiGiaoHang: '',
  giaoGap: false,
  thoiGianHen: null,
  fileUrl: '',
  ghiChuSales: ''
}

export default {
  name: 'SalesDonHang',
  components: {
    VueEasyLightbox,
  },
  data () {
    return {
      viewMode: 'kanban',
      showModal: false,
      isEdit: false,
      form: {
        ...this.getEmptyForm(),
        thoiGianHenText: ''
      },
      thoiGianHenPreview: '',

      formError: null,
      pastedPreviewUrl: '',
      lightboxVisible: false,

      formDiemDungMoi: {
        tenDiemDung: '',
        diaChi: '',
        chiTietVatTu: '',
        loaiDiemDung: 'KHO_LAY',
        nguoiPhuTrachKhoId: null
      },
      formHoachDinh: {
        diemDungList: []
      },
      tempBlobUrl: null,  
      isUploading: false,
      uploadError: null,
      tabs: [
        { value: null, label: 'Tất cả' },
        { value: 'CHO_HOACH_DINH', label: 'Chờ Kho Hoạch Định', icon: 'fa fa-sitemap' },
        { value: 'CHO_SALES_XAC_NHAN_THIEU', label: 'Chờ Tôi Xác Nhận', icon: 'fa fa-exclamation-triangle text-danger' },
        { value: 'DANG_CHUAN_BI_HANG', label: 'Đang Chuẩn Bị' },
        { value: 'SAN_SANG_GIAO', label: 'Sẵn Sàng Giao' },
        { value: 'DANG_VAN_CHUYEN', label: 'Đang Giao' },
        { value: 'HOAN_THANH', label: 'Hoàn thành' },
        { value: 'THAT_BAI', label: 'Thất bại' },
      ]
    }
  },
  computed: {
    ...mapState(useSalesDonHangStore, [
      'isLoadingList', 'listError', 'items',
      'totalPages', 'totalElements', 'size', 'page',
      'filterTrangThai', 'isLoadingDetail', 'detailError', 'currentOrder',
      'isLoadingOptions', 'khoNhanVienOptions'
    ]),
    ...mapGetters(useSalesDonHangStore, ['currentPage']),
    pageSize: {
      get () { return this.size },
      set (v) { this.changeSize(v) }
    },
    groupedByStatus () {
      const groups = {}
      this.items.forEach(o => {
        if (!groups[o.trangThai]) groups[o.trangThai] = []
        groups[o.trangThai].push(o)
      })
      return groups
    },
    kanbanColumns () {
      return [
        { key: 'CHO_HOACH_DINH', title: 'Chờ Kho Hoạch định' },
        { key: 'CHO_SALES_XAC_NHAN_THIEU', title: 'Chờ Tôi xác nhận'},
        { key: 'DANG_CHUAN_BI_HANG', title: 'Chuẩn bị hàng' },
        { key: 'SAN_SANG_GIAO', title: 'Sẵn sàng' },
        { key: 'DANG_VAN_CHUYEN', title: 'Đang giao' },
        { key: 'HOAN_THANH', title: 'Hoàn thành' },
        { key: 'THAT_BAI', title: 'Thất bại' }

      ]
    },
    previewSource() {
        if (this.tempBlobUrl) {
          return this.tempBlobUrl;
        }
        return this.form.fileUrl; 
      },
    
    lightboxImages() {
      return this.previewSource ? [this.previewSource] : [];
    },
    
  },
    
  methods: {
    ...mapActions(useSalesDonHangStore, [
      'fetchList', 'fetchListAll', 'setPage', 'setSize', 'setFilterTrangThai',
      'openDetailModal', 'clearDetailModal', 'createDonHang',
      'confirmShortage', 'cancelOrder',
      'fetchKhoOptionsIfNeeded'
    ]),
    formatDate,
    formatDateTime,
    openGoogleMaps,
    getOrderStatusBadge,
    formatOrderStatus,
    getLoaiBadgeStop,
    formatLoaiDiemDung,
    getStopStatusBadge,
    formatStopStatus,
    setTomorrowTime () {
      const now = new Date()
      const tmr = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1,
        8, 0, 0
      )
      const dd = String(tmr.getDate()).padStart(2, '0')
      const MM = String(tmr.getMonth() + 1).padStart(2, '0')
      const yyyy = tmr.getFullYear()
      const HH = String(tmr.getHours()).padStart(2, '0')
      const mm = String(tmr.getMinutes()).padStart(2, '0')
      const ss = String(tmr.getSeconds()).padStart(2, '0')
      this.form.thoiGianHenText = `${dd}/${MM}/${yyyy} ${HH}:${mm}:${ss}`
      this.updateThoiGianHenPreview()
    },

    parseViDateTimeToDate (text) {
      if (!text) return null
      const parts = text.trim().split(' ')
      if (parts.length !== 2) return null
      const [datePart, timePart] = parts
      const d = datePart.split('/')
      if (d.length !== 3) return null
      const t = timePart.split(':')
      if (t.length < 2) return null

      const dd = parseInt(d[0], 10)
      const MM = parseInt(d[1], 10) - 1
      const yyyy = parseInt(d[2], 10)
      const HH = parseInt(t[0], 10)
      const mm = parseInt(t[1], 10)
      const ss = t[2] !== undefined ? parseInt(t[2], 10) : 0

      const jsDate = new Date(yyyy, MM, dd, HH, mm, ss)
      if (isNaN(jsDate.getTime())) return null
      return jsDate
    },

    parseViDateTimeToIso (text) {
      const jsDate = this.parseViDateTimeToDate(text)
      if (!jsDate) return null
      const year = jsDate.getFullYear()
      const month = String(jsDate.getMonth() + 1).padStart(2, '0')
      const day = String(jsDate.getDate()).padStart(2, '0')
      const hour = String(jsDate.getHours()).padStart(2, '0')
      const minute = String(jsDate.getMinutes()).padStart(2, '0')
      const second = String(jsDate.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day}T${hour}:${minute}:${second}`
    },

    updateThoiGianHenPreview () {
      const d = this.parseViDateTimeToDate(this.form.thoiGianHenText)
      if (!d) {
        this.thoiGianHenPreview = ''
        return
      }
      const dd = String(d.getDate()).padStart(2, '0')
      const MM = String(d.getMonth() + 1).padStart(2, '0')
      const yyyy = d.getFullYear()
      const HH = String(d.getHours()).padStart(2, '0')
      const mm = String(d.getMinutes()).padStart(2, '0')
      const ss = String(d.getSeconds()).padStart(2, '0')

      this.thoiGianHenPreview = `→ ${dd}/${MM}/${yyyy} lúc ${HH}h${mm}m${ss}s`
    },

    triggerFileSelect () {
      this.$refs.fileInputEl && this.$refs.fileInputEl.click()
    },

    handleFileSelect(e) {
      const file = e.target.files && e.target.files[0]

      if (!file) return
      
      this.__handleFileUpload(file, 'don_hang_sales');

      if (this.$refs.fileInputEl) {
        this.$refs.fileInputEl.value = null; 
      }
    },

    handlePaste (e) {
      const clipboardItems = e.clipboardData.items || []
      let file = null;
      for (let i = 0; i < clipboardItems.length; i++) {
        const item = clipboardItems[i]
        if (item.type.indexOf('image') !== -1) {
        file = item.getAsFile()
        break
        }
      }
        if (file) {
          this.__handleFileUpload(file, 'don_hang_sales');
        }
    },

    openLightboxFromPreview () {
      if (!this.previewSource) return
        this.lightboxVisible = true
    },

    closeLightbox() {
      this.lightboxVisible = false;
    },

    getLoaiBadge (loai) {
      switch (loai) {
        case 'GIAO_HANG': return 'badge-primary'
        case 'LAY_HANG': return 'badge-info'
        case 'KHACH_TU_LAY': return 'badge-warning'
        default: return 'badge-light'
      }
    },
    formatLoai (loai) {
      switch (loai) {
        case 'GIAO_HANG': return 'Giao hàng (Tài xế)'
        case 'LAY_HANG': return 'Lấy hàng (Tài xế)'
        case 'KHACH_TU_LAY': return 'Khách Tự Lấy'
        default: return loai
      }
    },
    getKhoNhanVienName (id) {
      if (!id || !this.khoNhanVienOptions) return ''
      const nv = this.khoNhanVienOptions.find(n => n.idNguoiDung === id)
      return nv ? nv.hoTen : `ID (${id})`
    },
    applyFilterTab (status) { this.setFilterTrangThai(status) },
    changeSize (newSize) { this.setSize(Number(newSize)) },
    goPage (p) {
      if (p < 1 || p > this.totalPages || p === this.currentPage) return
      this.setPage(p)
    },
    getEmptyForm () {
      return { ...DEFAULT_CREATE_FORM, tenCongTrinh: '' }
    },
    async openCreateModal () {
      this.isEdit = false
      this.formError = null
      this.form = this.getEmptyForm()
      this.formHoachDinh.diemDungList = []
      this.formDiemDungMoi = { tenDiemDung: '', diaChi: '', chiTietVatTu: '', loaiDiemDung: 'KHO_LAY', nguoiPhuTrachKhoId: null }
      this.pastedPreviewUrl = ''
      this.tempBlobUrl = null 
      this.isUploading = false
      this.uploadError = null 
      this.showModal = true
      lockBodyScroll()
      await this.fetchKhoOptionsIfNeeded()
    },
    async handleOpenDetail (id) {
      this.formError = null
      this.isEdit = true
      this.showModal = true
      lockBodyScroll()
      await this.openDetailModal(id)
    },
    closeModal () {
      this.showModal = false
      this.isEdit = false
      this.clearDetailModal()
      unlockBodyScroll()
    },
    addStop () {
      if (!this.formDiemDungMoi.tenDiemDung || !this.formDiemDungMoi.nguoiPhuTrachKhoId) {
        this.formError = 'Nếu hoạch định, phải nhập Tên Điểm Dừng và gán NV Kho.'
        return
      }
      if (this.formDiemDungMoi.loaiDiemDung === 'KHACH_TU_LAY') {
        this.form.loaiDonHang = 'KHACH_TU_LAY'
      }
      this.formHoachDinh.diemDungList.push({ ...this.formDiemDungMoi })
      this.formDiemDungMoi = { tenDiemDung: '', diaChi: '', chiTietVatTu: '', loaiDiemDung: 'KHO_LAY', nguoiPhuTrachKhoId: null }
      this.formError = null
    },
    removeStop (index) {
      this.formHoachDinh.diemDungList.splice(index, 1)
    },
    async submitCreateForm () {
      this.formError = null
      if (this.isUploading) {
        this.formError = "Đang upload ảnh, vui lòng chờ...";
        return;
      }
      const f = this.form
      if (
        !f.tenDonHang || !f.loaiDonHang ||    
        !f.tenNguoiNhan || !f.sdtNguoiNhan ||
        !f.diaChiGiaoHang ||
        !f.fileUrl
      ) {
        this.formError = 'Vui lòng nhập đầy đủ các trường bắt buộc (*).'
        return
      }
      try {
        const payload = {
          ...f,
          diemDungList: this.formHoachDinh.diemDungList
        }
        if (payload.thoiGianHen) {
          payload.thoiGianHen = normalizeDateTimeLocalForApi(payload.thoiGianHen)
        }
        await this.createDonHang(payload)
        this.closeModal()
        alert('Tạo yêu cầu thành công! (Đã gửi cho Kho)')
      } catch (e) {
        this.formError = this.detailError || 'Lỗi khi tạo yêu cầu.'
      }
    },
    async handleConfirmShortage (id) {
      const chiTietVatTuDaSua = prompt('Nhập chi tiết vật tư đã sửa đổi:', this.currentOrder.chiTietVatTu)
      const ghiChuSales = prompt("Nhập ghi chú (VD: 'Đã xác nhận với khách'):")
      if (!chiTietVatTuDaSua || !ghiChuSales) {
        alert('Phải nhập cả vật tư và ghi chú.')
        return
      }
      try {
        await this.confirmShortage({ id, chiTietVatTuDaSua, ghiChuSales })
        this.closeModal()
      } catch (e) {
        alert(this.detailError || 'Lỗi khi xác nhận.')
      }
    },
    async handleCancelOrder (id) {
      if (!confirm('Bạn có chắc chắn muốn HỦY đơn hàng này?')) return
      try {
        await this.cancelOrder(id)
        this.closeModal()
      } catch (e) {
        alert(this.detailError || 'Lỗi khi hủy đơn.')
      }
    },

    onLoaiDonHangChange () {},
    getStatusClass (st) {
      if (!st) return 'badge-light'
      if (st === 'HOAN_THANH') return 'badge-success'
      if (st === 'DANG_VAN_CHUYEN') return 'badge-info'
      return 'badge-secondary'
    },

    async __handleFileUpload(file, folderName = 'don_hang_sales') {
      if (!file || !file.type.startsWith('image/')) {
        alert('Chỉ hỗ trợ dán/chọn file hình ảnh.');
        return;
      }

      this.isUploading = true;
      this.uploadError = null;
      
      this.form.fileUrl = ''; 
      
      if (this.tempBlobUrl) {
        URL.revokeObjectURL(this.tempBlobUrl); 
      }
      this.tempBlobUrl = URL.createObjectURL(file);

      try {
        // 3. TẠO FORMDATA (Logic CỦA EM)
        const formData = new FormData();
        formData.append("files", file); 
        formData.append("folderName", folderName);

        // 4. GỌI fileService CỦA EM
        const response = await fileService.upload(formData);
        console.log("check: ", response)

        // 5. XỬ LÝ RESPONSE (Logic CỦA EM)
        if (response.data && response.data.length > 0) {
          // 6. GÁN URL THẬT (persistent URL) vào form
          this.form.fileUrl = response.data[0].location;
        } else {
          throw new Error("Upload thành công nhưng không nhận được URL");
        }
        
      } catch (err) {
        console.error("Lỗi upload ảnh:", err);
        this.uploadError = 'Lỗi upload ảnh. Vui lòng dán link thủ công.';
        this.form.fileUrl = ''; // Xóa URL lỗi
      } finally {

        if (this.tempBlobUrl) {
          URL.revokeObjectURL(this.tempBlobUrl);
        }
        this.tempBlobUrl = null; 
        this.isUploading = false;
      }
    },

    handleImageUpload (evt, diem) {
      const file = evt.target.files && evt.target.files[0]
      if (!file) return
      const objUrl = URL.createObjectURL(file)
      diem.imageUrl = objUrl
    },
    savePickupConfirmations () {}
  },
  mounted () {
    this.setFilterTrangThai(this.filterTrangThai)
  },
  beforeUnmount() {
    if (this.tempBlobUrl) {
      URL.revokeObjectURL(this.tempBlobUrl);
    }
  }
}
</script>

<style scoped>
.nav-tabs-scrollable {
  overflow-x: auto;
  white-space: nowrap;
}
.nav-tabs .nav-link {
  padding: 0.75rem 1.25rem;
}
.badge {
  font-weight: 500;
}
.modal-body {
  max-height: 75vh;
  overflow-y: auto;
}
.hover-card {
  cursor: pointer;
  transition: box-shadow .15s;
}
.hover-card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0,0,0,.15) !important;
}

.kanban-wrapper {
  width: 100%;
  overflow-x: auto;
}
.kanban-scroll {
  min-width: 900px;
  display: flex;
  align-items: flex-start;
}
.kanban-col {
  width: 260px;
  min-width: 260px;
  background: #f8f9fa;
  border: 1px solid #e5e7eb;
  border-radius: .5rem;
  margin-right: 1rem;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 260px);
}
.kanban-header {
  padding: .75rem .75rem .5rem;
  border-bottom: 1px solid #dee2e6;
  background: #fff;
  border-top-left-radius: .5rem;
  border-top-right-radius: .5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.kanban-body {
  padding: .75rem;
  overflow-y: auto;
  flex: 1;
}
.kanban-card {
  background: #fff;
  border-radius: .5rem;
  border: 1px solid #dee2e6;
  box-shadow: 0 .25rem .5rem rgba(0,0,0,.05);
  padding: .75rem .75rem .5rem;
  font-size: .9rem;
  margin-bottom: .75rem;
  cursor: pointer;
}
.kanban-card:last-child {
  margin-bottom: 0;
}
.kanban-footer {
  border-top: 1px solid #f1f1f1;
  padding-top: .5rem;
}
.kanban-empty {
  border: 2px dashed #d6d6d6;
  border-radius: .5rem;
  background: #fff;
}
.kanban-dot {
  width: .6rem;
  height: .6rem;
  border-radius: 50%;
  background: #6c757d;
  border: 2px solid #fff;
  box-shadow: 0 0 0 2px #fff;
}
.dot-CHO_HOACH_DINH { background:#17a2b8; }
.dot-DANG_CHUAN_BI_HANG { background:#ffc107; }
.dot-SAN_SANG_GIAO { background:#28a745; }
.dot-DANG_VAN_CHUYEN { background:#007bff; }
.dot-HOAN_THANH { background:#20c997; }

.create-modal-wrapper {
  border-radius: .75rem;
  overflow: hidden;
}
.create-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.create-left {
  flex: 1 1 320px;
  min-width: 280px;
}
.create-right {
  flex: 1 1 320px;
  min-width: 280px;
}
.section-block {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: .5rem;
  padding: 1rem;
  margin-bottom: 1rem;
}
.section-title {
  font-weight: 600;
  font-size: .9rem;
  display: flex;
  align-items: center;
  margin-bottom: .75rem;
}
.section-title .badge {
  font-size: .7rem;
}
.required-label::after {
  content:" *";
  color:#dc3545;
  font-weight:700;
  margin-left:2px;
}
.upload-dropzone {
  border: 2px dashed #cbd5e0;
  border-radius: .5rem;
  background: #f9fafb;
  padding: .75rem;
  cursor: pointer;
}
.preview-area {
  margin-top: .5rem;
}
.preview-thumb {
  border-radius:.5rem;
  overflow:hidden;
  background:#fff;
  border:1px solid #dee2e6;
  display:inline-block;
  max-width:100%;
}
.custom-control-label {
  cursor: pointer;
}
@media (max-width: 576px){
  .modal-dialog.modal-lg {
    margin:0;
    max-width:100%;
    height:100%;
  }
  .modal-content {
    min-height:100vh;
    border-radius:0;
  }
  .modal-body {
    max-height: calc(100vh - 140px);
  }
  .create-grid {
    flex-direction:column;
  }
}

.upload-dropzone {
  border: 2px dashed #cbd5e0;
  border-radius: .5rem;
  background: #f9fafb;
  padding: .75rem;
  cursor: pointer;
}
.clickable-thumb {
  cursor: zoom-in;
}
.preview-thumb {
  border-radius:.5rem;
  overflow:hidden;
  background:#fff;
  border:1px solid #dee2e6;
  display:inline-block;
  max-width:100%;
}

</style>
